import { useQuery } from 'urql';
import { streetPageQuery } from './streetPageQuery';
import { getSlugFromPathname } from '../../helpers/getSlugFromPathname';
import { useUrlContext } from '../../contexts/UrlContext/UrlContext';

export const useStreetPageQuery = () => {
  const { pathname } = useUrlContext();

  const [result] = useQuery({
    query: streetPageQuery,
    variables: { slug: getSlugFromPathname(pathname) },
  });

  return result;
};
